import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Button,
  Box,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

export default function SuccessDialog({ open, onClose }) {
  const handleOk = () => {
    onClose(); // Call the onClose prop to close dialog
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          overflow: "visible",
          borderRadius: 3,
          textAlign: "center",
          px: 2,
          pb: 4,
          pt: 6,
          minWidth: 300,
        },
      }}
    >
      {/* Circle with tick */}
      <Box
        sx={{
          position: "absolute",
          top: -40,
          left: "50%",
          transform: "translateX(-50%)",
          width: 80,
          height: 80,
          borderRadius: "50%",
          bgcolor: "green",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: 3,
        }}
      >
        <CheckIcon sx={{ fontSize: 50, color: "white" }} />
      </Box>

      {/* Body */}
      <DialogContent sx={{ mt: 4 }}>
        <DialogTitle sx={{ fontWeight: "bold", p: 0, mb: 1 }}>
          Successfully
        </DialogTitle>
        <Typography>Roster Created Successfully</Typography>
      </DialogContent>

      <Box sx={{ mt: 2, px: 2 }}>
        <Button
          variant="contained"
          color="success"
          onClick={handleOk}
          sx={{ borderRadius: 2, px: 4, width: "100%" }}
        >
          OK
        </Button>
      </Box>
    </Dialog>
  );
}